import React from "react";
import PdfViewer from "../../PdfViewer";

const PuestoPM = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/descripcion-puesto-pm.pdf`;
  /*const pdfUrl = "/pdf/descripcion-puesto-pm.pdf";*/

  return (
    <>
      <main>
        <div class="titulo">
          <h1>Descripción del Puesto: PM</h1>
        </div>
        <div className="pdf-container">
          <PdfViewer pdfUrl={pdfUrl} />
        </div>
      </main>
    </>
  );
};

 export default PuestoPM;
